import { useEffect, useState } from "react";
import { MapPin } from "lucide-react";
import { Card } from "@/components/ui/card";
import api from "@/lib/api";

const fmt = (iso) => new Date(iso).toLocaleString("it-IT", { timeZone: "Europe/Rome", day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });

export function WrongStorePanel() {
  const [data, setData] = useState(null);
  const [days, setDays] = useState(30);
  useEffect(() => { api.wrongStoreStats(days).then(setData).catch(() => setData(null)); }, [days]);
  if (!data) return null;
  return (
    <Card className="p-5 bg-card border-border space-y-3" data-testid="wrong-store-panel">
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <h3 className="font-display font-bold flex items-center gap-2"><MapPin className="h-4 w-4 text-amber-400" /> Codici giocati nella sede sbagliata</h3>
        <div className="flex items-center gap-2 text-xs">
          <select value={days} onChange={(e) => setDays(Number(e.target.value))} className="h-7 rounded-md border border-border bg-background px-2" data-testid="wrong-store-days">
            <option value={7}>7 giorni</option><option value={30}>30 giorni</option><option value={90}>90 giorni</option>
          </select>
          <span className="font-mono-code text-amber-300" data-testid="wrong-store-total">{data.total} tentativi</span>
        </div>
      </div>
      {data.total === 0 ? <p className="text-sm text-muted-foreground" data-testid="wrong-store-empty">Nessun tentativo fuori sede nel periodo.</p> : (
        <>
          <ul className="text-sm divide-y divide-border">
            {data.pairs.slice(0, 8).map((p) => (
              <li key={`${p.attempted_store}-${p.bound_store}`} className="flex items-center justify-between py-1.5 gap-2">
                <span className="truncate">Giocato a <b>{p.attempted_store}</b> → codice di <b>{p.bound_store}</b></span>
                <span className="font-mono-code text-amber-300 shrink-0">{p.count}</span>
              </li>
            ))}
          </ul>
          <p className="text-[11px] text-muted-foreground">Ultimi: {data.recent.slice(0, 3).map((r) => `${r.code} (${fmt(r.created_at)})`).join(" · ")}</p>
        </>
      )}
    </Card>
  );
}
